var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltips-model"},[_c('el-popover',{attrs:{"placement":"top-start","trigger":"click"}},[_c('pre',{staticClass:"result",attrs:{"id":'result-' + _vm.id}}),_c('em',{staticClass:"iconfont",attrs:{"slot":"reference"},slot:"reference"},[_vm._t("reference")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }